import { create } from 'zustand';

interface BlogState {
  selectedCategory: string;
  searchQuery: string;
  setBlogCategory: (categoryId: string) => void;
  setSearchQuery: (query: string) => void;
  resetFilters: () => void;
}

export const useBlogStore = create<BlogState>((set) => ({
  selectedCategory: 'all',
  searchQuery: '',
  setBlogCategory: (categoryId) => set({ selectedCategory: categoryId }),
  setSearchQuery: (query) => set({ searchQuery: query }),
  resetFilters: () => set({ selectedCategory: 'all', searchQuery: '' }),
}));
